<template>
    <div class="vr360-intro vr360-flex-column">
      <div  class="vr360-intro__slider"
            ref="slider"
            :class="{'js-no-transition': !isAutoScrolling}">
        <div class="vr360-intro__img-on-desktop"></div>
        <ul class="vr360-intro__img-list vr360-intro__img__layer vr360-intro__img__layer-3">
          <div class="vr360-intro__img__layer vr360-intro__img__layer-3--underline"></div>
          <li class="vr360-intro__img-list__item">
            <div class="vr360-intro__img__layer vr360-intro__img__layer-2 vr360-intro__img__layer-2--girl js-vr360-intro__img__layer__parallax" data-trans-x="25">
            </div>
            <div class="vr360-intro__img__layer vr360-intro__img__layer-1 vr360-intro__img__layer-1--phone js-vr360-intro__img__layer__parallax" data-trans-x="-150">
            </div>
          </li>
          <li class="vr360-intro__img-list__item">
            <div class="vr360-intro__img__layer vr360-intro__img__layer-2 vr360-intro__img__layer-2--mountains js-vr360-intro__img__layer__parallax" data-trans-x="-20">
            </div>
            <div class="vr360-intro__img__layer vr360-intro__img__layer-1 vr360-intro__img__layer-1--man js-vr360-intro__img__layer__parallax" data-trans-x="-470">
            </div>
          </li>
          <li class="vr360-intro__img-list__item">
            <div class="vr360-intro__img__layer vr360-intro__img__layer-2 vr360-intro__img__layer-2--trees js-vr360-intro__img__layer__parallax" data-trans-x="8">
            </div>
            <div class="vr360-intro__img__layer vr360-intro__img__layer-1 vr360-intro__img__layer-1--bug js-vr360-intro__img__layer__parallax" data-trans-x="85">
            </div>
          </li>
        </ul>

        <ul class="vr360-intro__text-list">
          <li class="vr360-intro__text-list__item">
            <div class="vr360-intro__text">
              <h1 class="vr360-head-h1">Make you own unique 360 VR content</h1>
              <p class="vr360-text-reg">Use smartphone or almost all modern
                360 degrees cameras to stream stunning moments</p>
            </div>
          </li>
          <li class="vr360-intro__text-list__item">
            <div class="vr360-intro__text">
              <h1 class="vr360-head-h1">Share it with your friends or make public</h1>
              <p class="vr360-text-reg">You can select privacy settings when you start go live and change it anytime
                after</p>
            </div>
          </li>
          <li class="vr360-intro__text-list__item">
            <div class="vr360-intro__text">
              <h1 class="vr360-head-h1">4K, 8K, yes, you can!</h1>
              <p class="vr360-text-reg">You read right, we can stream online 8K video with perfect multichannel sounds.</p>
            </div>
          </li>
        </ul>
      </div>

      <ul class="vr360-radio-slider-list" ref="radioBtnsList">
        <li class="vr360-radio-slider-list__item">
          <label>
            <input type="radio" name="intro-slider" value="0" v-model="radioSwitcher" checked>
            <span></span>
          </label>
        </li>
        <li class="vr360-radio-slider-list__item">
          <label>
            <input type="radio" name="intro-slider" value="1" v-model="radioSwitcher">
            <span></span>
          </label>
        </li>
        <li class="vr360-radio-slider-list__item">
          <label>
            <input type="radio" name="intro-slider" value="2" v-model="radioSwitcher">
            <span></span>
          </label>
        </li>
      </ul>

      <router-link class="vr360-head-h4 vr360-text-blue vr360-link" :to="{name: 'app'}">Skip</router-link>
    </div>
</template>

<script>
export default {
  name: "Onboarding",
  data() {
    return {
      isAutoScrolling: false,
      radioSwitcher: 0
    };
  },
  mounted() {
    this.minTransX = 0;
    this.maxTransX = -200;
    this.slider = this.$refs.slider;
    this.parallaxElem = Array.from(
      this.slider.querySelectorAll(".js-vr360-intro__img__layer__parallax")
    );
    this.radioBtns = Array.from(
      this.$refs.radioBtnsList.querySelectorAll(`input[type="radio"]`)
    );

    this.startPointX = 0;
    this.shiftX = 0;
    this.tempShiftX = 0;

    this.slider.addEventListener("touchstart", this.sliderTouchStart, false);
    this.slider.addEventListener("touchmove", this.sliderTouchMove, false);
    this.slider.addEventListener("touchend", this.sliderTouchEnd, false);
    this.slider.addEventListener("touchcancel", this.sliderTouchEnd, false);
    this.radioBtns.forEach(radioBtn =>
      radioBtn.addEventListener("input", this.translateByRadio, false)
    );
  },
  methods: {
    translateX(el, value, units) {
      el.style.transform = `translateX(${value}${units})`;
    },
    translateSlider(value) {
      if (this.isOverEdge(value)) {
        this.translateX(this.slider, value, "%");
        this.translateParallaxElem(value);
        return true;
      } else {
        return false;
      }
    },
    translateParallaxElem(value) {
      this.parallaxElem.forEach(elem =>
        this.translateX(
          elem,
          parseInt((value / this.maxTransX) * parseInt(elem.dataset.transX)),
          "%"
        )
      );
    },
    isOverEdge(value) {
      return value <= this.minTransX && value >= this.maxTransX;
    },
    sliderTouchStart(e) {
      if (this.isAutoScrolling) return;
      this.startPointX = e.changedTouches[0].clientX;
    },
    sliderTouchMove(e) {
      if (this.isAutoScrolling) return;

      this.tempShiftX = parseInt(
        ((e.changedTouches[0].clientX - this.startPointX) /
          this.slider.offsetWidth) *
          100
      );
      this.translateSlider(this.shiftX + this.tempShiftX);
    },
    sliderTouchEnd() {
      if (this.isAutoScrolling) return;

      this.isAutoScrolling = true;

      if (Math.abs(this.tempShiftX) < 25) {
        this.tempShiftX = 0;
      } else {
        this.tempShiftX = this.tempShiftX < 0 ? -100 : 100;
      }

      if (this.translateSlider(this.shiftX + this.tempShiftX)) {
        setTimeout(() => {
          this.endAutoScrolling();
        }, 250);
      } else {
        this.isAutoScrolling = false;
      }
    },
    switchRadioBtn(value) {
      this.radioBtns[value].checked = true;
    },
    translateByRadio(e) {
      this.tempShiftX = 0;
      this.shiftX = parseInt(e.target.value * -100);
      this.sliderTouchEnd();
    },
    endAutoScrolling() {
      this.shiftX += this.tempShiftX;
      this.radioSwitcher = Math.abs(this.shiftX / 100);
      this.isAutoScrolling = false;
    }
  },
  watch: {
    radioSwitcher(value) {
      this.switchRadioBtn(parseInt(value));
    }
  }
};
</script>

<style lang="scss">
</style>
